import React from 'react';
import { useDroppable } from '@dnd-kit/core';

const Droppable = ({ id, children }) => {
  const { isOver, setNodeRef } = useDroppable({ id });
  
  const bucketStyle = {
    padding: '10px',
    backgroundColor: isOver ? 'rgba(74, 158, 255, 0.2)' : 'rgba(0, 0, 0, 0.5)',
    borderRadius: '8px',
    boxShadow: isOver ? 
      '0 4px 16px rgba(74, 158, 255, 0.3), inset 0 0 0 2px rgba(74, 158, 255, 0.5)' : 
      '0 4px 6px rgba(0, 0, 0, 0.1)',
    minHeight: '500px',
    maxWidth: '340px',
    minWidth: '340px',
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
    flex: 1,
    color: 'white',
    transition: 'all 0.2s ease',
    border: isOver ? '2px dashed rgba(74, 158, 255, 0.8)' : '2px solid transparent',
  };
  
  return (
    <div ref={setNodeRef} style={bucketStyle}>
      {children}
    </div>
  );
};

export default Droppable;
